import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-about-us',
    imports: [CommonModule, RouterModule],
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent {
  contributors: any = [
    // {
    //   name: 'Mahbob Al-Homidy',
    //   initials: 'MA',
    //   role: 'Generative AI Engineer',
    //   isOnline: true,
    // },
    // {
    //   name: 'Madhan Mohan',
    //   initials: 'MM',
    //   role: 'Generative AI Engineer',
    //   isOnline: true,
    // },
    {
      name: 'Aditi Sharma',
      initials: 'AS',
      role: 'UI/UX Designer',
      isAccent: true,
    },

    {
      name: 'Anjali Negi',
      initials: 'AN',
      role: 'Frontend Developer',
      isAccent: true,
    },
    {
      name: 'Ashwin Bhatt',
      initials: 'AN',
      role: 'Frontend Developer',
      isAccent: false,
    },

    {
      name: 'Mansi Chawla',
      initials: 'MC',
      role: 'DevOps Engineer',
      isAccent: false,
    },
  ];

  navigateToContact() {}
}
